import Select from "react-select";
import select_styles from "../../../../../../../../../layouts/elements";
import {useState} from "react";
import {Input, InputWrapperDiv} from "../../../../../../../../../components/ui/Input";
import {Button} from "../../../../../../../../../components/ui/Button";
import { v4 as uuidv4 } from "uuid";


const categories_list = [
    {value: "-----", label: "-----"},
    {value: "Administration", label: "Administration"},
    {value: "Archiving", label: "Archiving"},
    {value: "Renting", label: "Renting"},
    {value: "Transport", label: "Transport"},
    {value: "Other", label: "Other"},
]

const AdditionalCostPopupForm = ({handlePopup, formData, saveBtn, cancelBtn}) => {
    const [categorieSel, setCategorieSel] = useState(categories_list[0]);
    const [title, setTitle] = useState("");

    const changeHandler = (value, type) => {
        if (type === "categorie") {
            setCategorieSel(value);
        } else {
            setTitle(value);
        }
    }

    const handleClickFactory = (e) => {
        const buttonName = e.target.name

        if (buttonName === 'save') {
            if (categorieSel.value === categories_list[0].value || !title) return
            return handlePopup("save", formData, {
                id: uuidv4(),
                categorie: categorieSel.value,
                title: title,
                client_cost: "0.00", estro_cost: "0.00",
            });
        }
        if (buttonName === 'cancel') {
            return handlePopup("cancel")
        }
    };

    return (<>
        <div>
            <Select
                options={categories_list}
                value={categorieSel}
                onChange={val => changeHandler(val, "categorie")}
                styles={select_styles}
                // isSearchable={false}
                unstyled
            />
        </div>

        <div className='row pb-2'>
            <InputWrapperDiv>
                <Input
                    placeholder='Title *'
                    name='title_categorie'
                    value={title}
                    onChange={val => changeHandler(val, "title")}
                    readOnly={true}
                />
            </InputWrapperDiv>
        </div>

        <Button name="save" onClick={(e) => handleClickFactory(e)}
                variant="round" bWidth="small" styling="plain" className='mx-3' proposueButton="green">{saveBtn}
        </Button>
        <Button name="cancel" onClick={(e) => handleClickFactory(e)}
                variant="round" bWidth="small" styling="bordered" className='mx-3'>{cancelBtn}
        </Button>
    </>)
}

export default AdditionalCostPopupForm;
